import React from 'react';
import Image from "react-bootstrap/Image"
import logo from '../../images/unnamed.jpg'
import Helmet from "react-helmet"
import "../../Utils/fonts/index.css"

const Header = () => {

    return ( 

        <>
        <Helmet>
          <title>{"Mi Súper"}</title>
          <meta name="description" content={"Mi Súper"} />
        </Helmet>
        <header className="d-flex header-resposive-ss">
          <Image src={logo} className="logo-responsive" />
        </header>
      </>

     );
}
 
export default Header;